import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot, Params } from '@angular/router';
import { filter, Observable, of, switchMap, take } from 'rxjs';

import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';
import { INITIAL_DEFAULT_FOLDER_ID, SYSTEM_FOLDERS_INFO } from '@folders/constants/folder.constants';
import { SettingsStoreService } from '@settings/store/services/settings-store.service';
import { MyListingsStoreService } from '@my-listings/store/services/my-listings-store.service';
import { INITIAL_EMAIL_LAYOUT_STATE } from '@my-listings/constants/initial-email-layout-state.constants';

export const myListingsGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, _: RouterStateSnapshot) => {
    const params = route.queryParams;
    const routeService = inject(RouteService);
    const myListingsStoreService = inject(MyListingsStoreService);

    const state = routeService.getNavigationState<{ processDefaultFolder: boolean | null }>();

    if (params?.tab != null) {
        routeService.navigate(RpcRoute.Portfolio).catch(() => { });

        return of(false);
    } else if (route.firstChild?.routeConfig?.path !== '') {
        if (params?.filter) {
            handleRedirectToFolderWithFilter(params, myListingsStoreService);

            return of(false);
        }

        return of(true);
    }

    return state?.processDefaultFolder === false ? of(true) : handlePortfolioRoute(myListingsStoreService);
};

const handleRedirectToFolderWithFilter = (params: Params, myListingsStoreService: MyListingsStoreService): void => {
    const navigationState = INITIAL_EMAIL_LAYOUT_STATE.get(params?.filter);

    myListingsStoreService.navigateToFolder(
        SYSTEM_FOLDERS_INFO.ALL_HOMES.id,
        navigationState
    );
};

const handlePortfolioRoute = (myListingsStoreService: MyListingsStoreService): Observable<boolean> => {
    return inject(SettingsStoreService).defaultFolderId$.pipe(
        filter(defaultFolderId => defaultFolderId !== INITIAL_DEFAULT_FOLDER_ID),
        take(1),
        switchMap(defaultFolderId => {
            if (defaultFolderId != null) {
                myListingsStoreService.navigateToFolder(defaultFolderId, null);

                return of(false);
            }

            return of(true);
        })
    );
};